import {UILayout} from '@gongxigames/framework/slotV2/types/UIPresetManager';
import {Rectangle} from 'pixi.js';

export const UI_LAYOUTS: UILayout[] = [
    {
        gameProvider: 'ruby',
        name:'default',
        resourcesPackage :'ruby-default',
        uiAreaSize: {
            landscape: {width: 1920, height: 1080},
            portrait: {width: 1080, height: 1920},
        },
        gameWindow: {
            landscape: new Rectangle(1920*0.1, 0, 1920*0.8, 1080*0.8),
            portrait: new Rectangle(0, 1920*0.12, 1080, 1920*0.65),
        }
    },
    {
        gameProvider: 'koala',
        name:'default',
        resourcesPackage :'koala-default',
        uiAreaSize: {
            landscape: {width: 1920, height: 1080},
            portrait: {width: 1080, height: 1920},
        },
        gameWindow: {
            landscape: new Rectangle(1920*0.1, 0, 1920*0.8, 1080*0.8),
            portrait: new Rectangle(0, 1920*0.035, 1080, 1920*0.59),
        }
    }
];